module.exports = __webpack_public_path__ + "img/06-AppDNF-03.ce70412a.png";